// import { parsePlayer } from "../utils";

// Champions lineup
export const lineup  = JSON.parse(`{
    "homeLineup": {
        "team": {
            "id": "GN1HA5EQ6XQ88SQ",
            "names": {
                "default": "Ucrania",
                "full": "Ucrania",
                "short": "Ucrania",
                "abbreviation": "UKR"
            },
            "typeDetail": "TEAM_NATIONAL",
            "images": {
                "teamLogo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3095.png",
                "jersey": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/shirt_home/large/3095.png"
            },
            "nationality": {
                "names": {
                    "default": "Ucrania",
                    "abbreviation": "UKR"
                },
                "images": {
                    "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2232.png"
                }
            },
            "properties": {
                "formation": "4-3-3"
            }
        },
        "teamMembers": [
            {
                "id": "GNASV5VPQAP1WTH",
                "names": {
                    "first": "Heorhiy",
                    "last": "Buschan",
                    "short": "H. Buschan",
                    "default": "Heorhiy Buschan"
                },
                "images": {},
                "nationality": {
                    "names": {
                        "default": "Ucrania",
                        "abbreviation": "UKR"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2232.png"
                    }
                },
                "dateOfBirth": "1994-05-31",
                "properties": {
                    "position": {
                        "key": "GOALKEEPER",
                        "names": {
                            "default": "Goalkeeper",
                            "short": "G"
                        }
                    },
                    "lineupStatus": {
                        "key": "STARTER",
                        "names": {
                            "default": "Starter",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "1",
                    "positionNumber": "1"
                }
            },
            {
                "id": "GN6R6ZGNZFHG07C",
                "names": {
                    "last": "Karavaiev",
                    "default": "Oleksandr Karavaiev",
                    "short": "O. Karavaiev",
                    "first": "Oleksandr"
                },
                "images": {
                    "playerHeadshotNational": "https://images.sports.gracenote.com/images/lib/basic/person/pp_nationalteam/large/1188975.jpg"
                },
                "nationality": {
                    "names": {
                        "default": "Ucrania",
                        "abbreviation": "UKR"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2232.png"
                    }
                },
                "dateOfBirth": "1992-06-02",
                "properties": {
                    "position": {
                        "key": "DEFENDER",
                        "names": {
                            "default": "Defender",
                            "short": "D"
                        }
                    },
                    "lineupStatus": {
                        "key": "STARTER",
                        "names": {
                            "default": "Starter",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "21",
                    "positionNumber": "2"
                }
            },
            {
                "id": "GNBBZHXK18FZ7A5",
                "names": {
                    "default": "Illia Zabarnyi",
                    "last": "Zabarnyi",
                    "first": "Illia",
                    "short": "I. Zabarnyi"
                },
                "images": {},
                "nationality": {
                    "names": {
                        "default": "Ucrania",
                        "abbreviation": "UKR"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2232.png"
                    }
                },
                "dateOfBirth": "2002-09-01",
                "properties": {
                    "position": {
                        "key": "DEFENDER",
                        "names": {
                            "default": "Defender",
                            "short": "D"
                        }
                    },
                    "lineupStatus": {
                        "key": "STARTER",
                        "names": {
                            "default": "Starter",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "13",
                    "positionNumber": "3"
                }
            },
            {
                "id": "GN87NFD7RTB6ARK",
                "names": {
                    "first": "Mykola",
                    "short": "M. Matviyenko",
                    "default": "Mykola Matviyenko",
                    "last": "Matviyenko"
                },
                "images": {
                    "playerHeadshotNational": "https://images.sports.gracenote.com/images/lib/basic/person/pp_nationalteam/large/1402379.jpg"
                },
                "nationality": {
                    "names": {
                        "default": "Ucrania",
                        "abbreviation": "UKR"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2232.png"
                    }
                },
                "dateOfBirth": "1996-05-02",
                "properties": {
                    "position": {
                        "key": "DEFENDER",
                        "names": {
                            "default": "Defender",
                            "short": "D"
                        }
                    },
                    "lineupStatus": {
                        "key": "STARTER",
                        "names": {
                            "default": "Starter",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "22",
                    "positionNumber": "4"
                }
            },
            {
                "id": "GNAFDXJC8M7T9JQ",
                "names": {
                    "last": "Mykolenko",
                    "default": "Vitaliy Mykolenko",
                    "short": "V. Mykolenko",
                    "first": "Vitaliy"
                },
                "images": {},
                "nationality": {
                    "names": {
                        "default": "Ucrania",
                        "abbreviation": "UKR"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2232.png"
                    }
                },
                "dateOfBirth": "1999-05-29",
                "properties": {
                    "position": {
                        "key": "DEFENDER",
                        "names": {
                            "default": "Defender",
                            "short": "D"
                        }
                    },
                    "lineupStatus": {
                        "key": "STARTER",
                        "names": {
                            "default": "Starter",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "16",
                    "positionNumber": "5"
                }
            },
            {
                "id": "GNCW7YGE5QQ9FS3",
                "names": {
                    "last": "Zinchenko",
                    "short": "O. Zinchenko",
                    "first": "Oleksandr",
                    "default": "Oleksandr Zinchenko"
                },
                "images": {
                    "playerHeadshotNational": "https://images.sports.gracenote.com/images/lib/basic/person/pp_nationalteam/large/1362057.jpg",
                    "playerHeadshot": "https://images.sports.gracenote.com/images/lib/basic/person/pp_clubteam/large/1362057.jpg"
                },
                "nationality": {
                    "names": {
                        "default": "Ucrania",
                        "abbreviation": "UKR"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2232.png"
                    }
                },
                "dateOfBirth": "1996-12-15",
                "properties": {
                    "position": {
                        "key": "MIDFIELDER",
                        "names": {
                            "default": "Midfielder",
                            "short": "M"
                        }
                    },
                    "lineupStatus": {
                        "key": "STARTER",
                        "names": {
                            "default": "Starter",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "17",
                    "positionNumber": "8"
                }
            },
            {
                "id": "GN10WCKWK7CMD6S",
                "names": {
                    "short": "A. Yarmolenko",
                    "last": "Yarmolenko",
                    "first": "Andriy",
                    "default": "Andriy Yarmolenko"
                },
                "images": {
                    "playerHeadshotNational": "https://images.sports.gracenote.com/images/lib/basic/person/pp_nationalteam/large/729528.jpg",
                    "playerHeadshot": "https://images.sports.gracenote.com/images/lib/basic/person/pp_clubteam/large/729528.jpg"
                },
                "nationality": {
                    "names": {
                        "default": "Ucrania",
                        "abbreviation": "UKR"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2232.png"
                    }
                },
                "dateOfBirth": "1989-10-23",
                "properties": {
                    "position": {
                        "key": "FORWARD",
                        "names": {
                            "default": "Forward",
                            "short": "F"
                        }
                    },
                    "role": {
                        "key": "CAPTAIN",
                        "names": {
                            "default": "Captain",
                            "short": "C"
                        }
                    },
                    "lineupStatus": {
                        "key": "STARTER",
                        "names": {
                            "default": "Starter",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "7",
                    "positionNumber": "9"
                }
            },
            {
                "id": "GN796SYKRY4W712",
                "names": {
                    "short": "R. Malinovskiy",
                    "first": "Ruslan",
                    "last": "Malinovskiy",
                    "default": "Ruslan Malinovskiy"
                },
                "images": {
                    "playerHeadshot": "https://images.sports.gracenote.com/images/lib/basic/person/pp_clubteam/large/1254630.jpg",
                    "playerHeadshotNational": "https://images.sports.gracenote.com/images/lib/basic/person/pp_nationalteam/large/1254630.jpg"
                },
                "nationality": {
                    "names": {
                        "default": "Ucrania",
                        "abbreviation": "UKR"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2232.png"
                    }
                },
                "dateOfBirth": "1993-05-04",
                "properties": {
                    "position": {
                        "key": "FORWARD",
                        "names": {
                            "default": "Forward",
                            "short": "F"
                        }
                    },
                    "lineupStatus": {
                        "key": "STARTER",
                        "names": {
                            "default": "Starter",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "8",
                    "positionNumber": "11"
                }
            },
            {
                "id": "GN8DVA4QGVYD8QT",
                "names": {
                    "short": "R. Yaremchuk",
                    "last": "Yaremchuk",
                    "default": "Roman Yaremchuk",
                    "first": "Roman"
                },
                "images": {
                    "playerHeadshotNational": "https://images.sports.gracenote.com/images/lib/basic/person/pp_nationalteam/large/1291332.jpg",
                    "playerHeadshot": "https://images.sports.gracenote.com/images/lib/basic/person/pp_clubteam/large/1291332.jpg"
                },
                "nationality": {
                    "names": {
                        "default": "Ucrania",
                        "abbreviation": "UKR"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2232.png"
                    }
                },
                "dateOfBirth": "1995-11-27",
                "properties": {
                    "position": {
                        "key": "FORWARD",
                        "names": {
                            "default": "Forward",
                            "short": "F"
                        }
                    },
                    "lineupStatus": {
                        "key": "STARTER",
                        "names": {
                            "default": "Starter",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "9",
                    "positionNumber": "10"
                }
            },
            {
                "id": "GN32G79CEGSZTQD",
                "names": {
                    "default": "Taras Stepanenko",
                    "last": "Stepanenko",
                    "short": "T. Stepanenko",
                    "first": "Taras"
                },
                "images": {
                    "playerHeadshot": "https://images.sports.gracenote.com/images/lib/basic/person/pp_clubteam/large/695734.jpg",
                    "playerHeadshotNational": "https://images.sports.gracenote.com/images/lib/basic/person/pp_nationalteam/large/695734.jpg"
                },
                "nationality": {
                    "names": {
                        "default": "Ucrania",
                        "abbreviation": "UKR"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2232.png"
                    }
                },
                "dateOfBirth": "1989-08-08",
                "properties": {
                    "position": {
                        "key": "MIDFIELDER",
                        "names": {
                            "default": "Midfielder",
                            "short": "M"
                        }
                    },
                    "lineupStatus": {
                        "key": "STARTER",
                        "names": {
                            "default": "Starter",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "6",
                    "positionNumber": "7"
                }
            },
            {
                "id": "GNAS3AE5PA0XWBX",
                "names": {
                    "default": "Mykola Shaparenko",
                    "last": "Shaparenko",
                    "short": "M. Shaparenko",
                    "first": "Mykola"
                },
                "images": {},
                "nationality": {
                    "names": {
                        "default": "Ucrania",
                        "abbreviation": "UKR"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2232.png"
                    }
                },
                "dateOfBirth": "1998-10-04",
                "properties": {
                    "position": {
                        "key": "MIDFIELDER",
                        "names": {
                            "default": "Midfielder",
                            "short": "M"
                        }
                    },
                    "lineupStatus": {
                        "key": "STARTER",
                        "names": {
                            "default": "Starter",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "10",
                    "positionNumber": "6"
                }
            },
            {
                "id": "GN5A70R7NJFC8EJ",
                "names": {
                    "short": "A. Pyatov",
                    "last": "Pyatov",
                    "default": "Andriy Pyatov",
                    "first": "Andriy"
                },
                "images": {
                    "playerHeadshotNational": "https://images.sports.gracenote.com/images/lib/basic/person/pp_nationalteam/large/612804.jpg",
                    "playerHeadshot": "https://images.sports.gracenote.com/images/lib/basic/person/pp_clubteam/large/612804.jpg"
                },
                "nationality": {
                    "names": {
                        "default": "Ucrania",
                        "abbreviation": "UKR"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2232.png"
                    }
                },
                "dateOfBirth": "1984-06-28",
                "properties": {
                    "lineupStatus": {
                        "key": "SUBSTITUTE",
                        "names": {
                            "default": "Substitute",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "12"
                }
            },
            {
                "id": "GN9QH0E3QYY97JX",
                "names": {
                    "last": "Trubin",
                    "short": "A. Trubin",
                    "default": "Anatoliy Trubin",
                    "first": "Anatoliy"
                },
                "images": {},
                "nationality": {
                    "names": {
                        "default": "Ucrania",
                        "abbreviation": "UKR"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2232.png"
                    }
                },
                "dateOfBirth": "2001-08-01",
                "properties": {
                    "lineupStatus": {
                        "key": "SUBSTITUTE",
                        "names": {
                            "default": "Substitute",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "23"
                }
            },
            {
                "id": "GN71YSQGKFPJ1ME",
                "names": {
                    "last": "Sobol",
                    "default": "Eduard Sobol",
                    "short": "E. Sobol",
                    "first": "Eduard"
                },
                "images": {
                    "playerHeadshot": "https://images.sports.gracenote.com/images/lib/basic/person/pp_clubteam/large/1188983.jpg"
                },
                "nationality": {
                    "names": {
                        "default": "Ucrania",
                        "abbreviation": "UKR"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2232.png"
                    }
                },
                "dateOfBirth": "1995-04-20",
                "properties": {
                    "position": {
                        "key": "DEFENDER",
                        "names": {
                            "default": "Defender",
                            "short": "D"
                        }
                    },
                    "lineupStatus": {
                        "key": "SUBSTITUTE",
                        "names": {
                            "default": "Substitute",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "2",
                    "positionNumber": "11"
                }
            },
            {
                "id": "GN3A2FDD1FGBSYC",
                "names": {
                    "default": "Heorhiy Sudakov",
                    "short": "H. Sudakov",
                    "first": "Heorhiy",
                    "last": "Sudakov"
                },
                "images": {},
                "nationality": {
                    "names": {
                        "default": "Ucrania",
                        "abbreviation": "UKR"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2232.png"
                    }
                },
                "dateOfBirth": "2002-09-01",
                "properties": {
                    "lineupStatus": {
                        "key": "SUBSTITUTE",
                        "names": {
                            "default": "Substitute",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "3"
                }
            },
            {
                "id": "GNEMEP13FPDMJ3R",
                "names": {
                    "default": "Serhiy Kryvtsov",
                    "short": "S. Kryvtsov",
                    "first": "Serhiy",
                    "last": "Kryvtsov"
                },
                "images": {},
                "nationality": {
                    "names": {
                        "default": "Ucrania",
                        "abbreviation": "UKR"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2232.png"
                    }
                },
                "dateOfBirth": "1991-03-15",
                "properties": {
                    "lineupStatus": {
                        "key": "SUBSTITUTE",
                        "names": {
                            "default": "Substitute",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "4"
                }
            },
            {
                "id": "GN5EQGTH7KYHGYH",
                "names": {
                    "last": "Sydorchuk",
                    "first": "Serhiy",
                    "short": "S. Sydorchuk",
                    "default": "Serhiy Sydorchuk"
                },
                "images": {
                    "playerHeadshotNational": "https://images.sports.gracenote.com/images/lib/basic/person/pp_nationalteam/large/866955.jpg"
                },
                "nationality": {
                    "names": {
                        "default": "Ucrania",
                        "abbreviation": "UKR"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2232.png"
                    }
                },
                "dateOfBirth": "1991-05-02",
                "properties": {
                    "position": {
                        "key": "MIDFIELDER",
                        "names": {
                            "default": "Midfielder",
                            "short": "M"
                        }
                    },
                    "lineupStatus": {
                        "key": "SUBSTITUTE",
                        "names": {
                            "default": "Substitute",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "5",
                    "positionNumber": "6"
                }
            },
            {
                "id": "GN173C20VXXT3A5",
                "names": {
                    "short": "Marlos",
                    "default": "Marlos",
                    "last": "Marlos"
                },
                "images": {
                    "playerHeadshotNational": "https://images.sports.gracenote.com/images/lib/basic/person/pp_nationalteam/large/736515.jpg"
                },
                "nationality": {
                    "names": {
                        "default": "Ucrania",
                        "abbreviation": "UKR"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2232.png"
                    }
                },
                "dateOfBirth": "1988-06-07",
                "properties": {
                    "lineupStatus": {
                        "key": "SUBSTITUTE",
                        "names": {
                            "default": "Substitute",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "11"
                }
            },
            {
                "id": "GNDX7CP3685JE5S",
                "names": {
                    "first": "Yevhen",
                    "short": "Y. Makarenko",
                    "default": "Evgeniy Makarenko",
                    "last": "Makarenko"
                },
                "images": {},
                "nationality": {
                    "names": {
                        "default": "Ucrania",
                        "abbreviation": "UKR"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2232.png"
                    }
                },
                "dateOfBirth": "1991-05-21",
                "properties": {
                    "lineupStatus": {
                        "key": "SUBSTITUTE",
                        "names": {
                            "default": "Substitute",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "14"
                }
            },
            {
                "id": "GNCGT9Y1DDT6976",
                "names": {
                    "default": "Viktor Tsyhankov",
                    "short": "V. Tsyhankov",
                    "last": "Tsyhankov",
                    "first": "Viktor"
                },
                "images": {},
                "nationality": {
                    "names": {
                        "default": "Ucrania",
                        "abbreviation": "UKR"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2232.png"
                    }
                },
                "dateOfBirth": "1997-11-15",
                "properties": {
                    "position": {
                        "key": "MIDFIELDER",
                        "names": {
                            "default": "Midfielder",
                            "short": "M"
                        }
                    },
                    "lineupStatus": {
                        "key": "SUBSTITUTE",
                        "names": {
                            "default": "Substitute",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "15",
                    "positionNumber": "9"
                }
            },
            {
                "id": "GN99RYB49QJZVBZ",
                "names": {
                    "default": "Artem Besyedin",
                    "short": "A. Besyedin",
                    "last": "Besyedin",
                    "first": "Artem"
                },
                "images": {},
                "nationality": {
                    "names": {
                        "default": "Ucrania",
                        "abbreviation": "UKR"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2232.png"
                    }
                },
                "dateOfBirth": "1996-03-31",
                "properties": {
                    "position": {
                        "key": "FORWARD",
                        "names": {
                            "default": "Forward",
                            "short": "F"
                        }
                    },
                    "lineupStatus": {
                        "key": "SUBSTITUTE",
                        "names": {
                            "default": "Substitute",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "19",
                    "positionNumber": "10"
                }
            },
            {
                "id": "GN5FHG4RDM8YM75",
                "names": {
                    "first": "Artem",
                    "default": "Artem Dovbyk",
                    "last": "Dovbyk",
                    "short": "A. Dovbyk"
                },
                "images": {},
                "nationality": {
                    "names": {
                        "default": "Ucrania",
                        "abbreviation": "UKR"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2232.png"
                    }
                },
                "dateOfBirth": "1997-06-21",
                "properties": {
                    "lineupStatus": {
                        "key": "SUBSTITUTE",
                        "names": {
                            "default": "Substitute",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "26"
                }
            },
            {
                "id": "GNCE3SPXS3GZK79",
                "names": {
                    "first": "Oleksandr",
                    "short": "O. Tymchyk",
                    "default": "Oleksandr Tymchyk",
                    "last": "Tymchyk"
                },
                "images": {},
                "nationality": {
                    "names": {
                        "default": "Ucrania",
                        "abbreviation": "UKR"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2232.png"
                    }
                },
                "dateOfBirth": "1997-01-20",
                "properties": {
                    "lineupStatus": {
                        "key": "SUBSTITUTE",
                        "names": {
                            "default": "Substitute",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "24"
                }
            }
        ],
        "coaches": [
            {
                "id": "GN3RQXTTHBVRPYB",
                "names": {
                    "default": "Andri Shevchenko",
                    "last": "Shevchenko",
                    "first": "Andri",
                    "short": "A. Shevchenko"
                },
                "images": {
                    "playerHeadshotNational": "https://images.sports.gracenote.com/images/lib/basic/person/pp_nationalteam/large/91691.jpg"
                },
                "nationality": {
                    "names": {
                        "default": "Ucrania",
                        "abbreviation": "UKR"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2232.png"
                    }
                },
                "dateOfBirth": "1976-09-29",
                "properties": {
                    "role": {
                        "key": "COACH",
                        "names": {
                            "default": "Coach",
                            "short": "C"
                        }
                    }
                }
            }
        ]
    },
    "awayLineup": {
        "team": {
            "id": "GN1R063FGB6VT6V",
            "names": {
                "default": "República de Macedonia del Norte",
                "abbreviation": "MKD",
                "short": "Macedonia",
                "full": "República de Macedonia del Norte"
            },
            "typeDetail": "TEAM_NATIONAL",
            "images": {
                "jersey": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/shirt_home/large/3092.png",
                "teamLogo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3092.png"
            },
            "nationality": {
                "names": {
                    "default": "República de Macedonia del Norte",
                    "abbreviation": "MKD"
                },
                "images": {
                    "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4358.png"
                }
            },
            "properties": {
                "formation": "5-3-2"
            }
        },
        "teamMembers": [
            {
                "id": "GNBW4SXRJ2PZ970",
                "names": {
                    "last": "Dimitrievski",
                    "default": "Stole Dimitrievski",
                    "short": "S. Dimitrievski",
                    "first": "Stole"
                },
                "images": {
                    "playerHeadshot": "https://images.sports.gracenote.com/images/lib/basic/person/pp_clubteam/large/953084.jpg",
                    "playerHeadshotNational": "https://images.sports.gracenote.com/images/lib/basic/person/pp_nationalteam/large/953084.jpg"
                },
                "nationality": {
                    "names": {
                        "default": "República de Macedonia del Norte",
                        "abbreviation": "MKD"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4358.png"
                    }
                },
                "dateOfBirth": "1993-12-25",
                "properties": {
                    "position": {
                        "key": "GOALKEEPER",
                        "names": {
                            "default": "Goalkeeper",
                            "short": "G"
                        }
                    },
                    "lineupStatus": {
                        "key": "STARTER",
                        "names": {
                            "default": "Starter",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "1",
                    "positionNumber": "1"
                }
            },
            {
                "id": "GNAVTZHF1R4661S",
                "names": {
                    "last": "Ristovski",
                    "default": "Stefan Ristovski",
                    "short": "S. Ristovski",
                    "first": "Stefan"
                },
                "images": {
                    "playerHeadshotNational": "https://images.sports.gracenote.com/images/lib/basic/person/pp_nationalteam/large/790196.jpg",
                    "playerHeadshot": "https://images.sports.gracenote.com/images/lib/basic/person/pp_clubteam/large/790196.jpg"
                },
                "nationality": {
                    "names": {
                        "default": "República de Macedonia del Norte",
                        "abbreviation": "MKD"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4358.png"
                    }
                },
                "dateOfBirth": "1992-02-12",
                "properties": {
                    "position": {
                        "key": "DEFENDER",
                        "names": {
                            "default": "Defender",
                            "short": "D"
                        }
                    },
                    "lineupStatus": {
                        "key": "STARTER",
                        "names": {
                            "default": "Starter",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "13",
                    "positionNumber": "3"
                }
            },
            {
                "id": "GN1YRSH6JMNDHGE",
                "names": {
                    "last": "Velkovski",
                    "first": "Darko",
                    "short": "D. Velkovski",
                    "default": "Darko Velkovski"
                },
                "images": {
                    "playerHeadshotNational": "https://images.sports.gracenote.com/images/lib/basic/person/pp_nationalteam/large/953096.jpg"
                },
                "nationality": {
                    "names": {
                        "default": "República de Macedonia del Norte",
                        "abbreviation": "MKD"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4358.png"
                    }
                },
                "dateOfBirth": "1995-06-21",
                "properties": {
                    "position": {
                        "key": "DEFENDER",
                        "names": {
                            "default": "Defender",
                            "short": "D"
                        }
                    },
                    "lineupStatus": {
                        "key": "STARTER",
                        "names": {
                            "default": "Starter",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "14",
                    "positionNumber": "4"
                }
            },
            {
                "id": "GN3GXPHK02S4G79",
                "names": {
                    "last": "Musliu",
                    "default": "Visar Musliu",
                    "first": "Visar",
                    "short": "V. Musliu"
                },
                "images": {
                    "playerHeadshotNational": "https://images.sports.gracenote.com/images/lib/basic/person/pp_nationalteam/large/953231.jpg"
                },
                "nationality": {
                    "names": {
                        "default": "República de Macedonia del Norte",
                        "abbreviation": "MKD"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4358.png"
                    }
                },
                "dateOfBirth": "1994-11-13",
                "properties": {
                    "position": {
                        "key": "DEFENDER",
                        "names": {
                            "default": "Defender",
                            "short": "D"
                        }
                    },
                    "lineupStatus": {
                        "key": "STARTER",
                        "names": {
                            "default": "Starter",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "6",
                    "positionNumber": "5"
                }
            },
            {
                "id": "GN2JP28QS1V6CP6",
                "names": {
                    "last": "Nikolov",
                    "default": "Boban Nikolov",
                    "short": "B. Nikolov",
                    "first": "Boban"
                },
                "images": {
                    "playerHeadshotNational": "https://images.sports.gracenote.com/images/lib/basic/person/pp_nationalteam/large/1075322.jpg"
                },
                "nationality": {
                    "names": {
                        "default": "República de Macedonia del Norte",
                        "abbreviation": "MKD"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4358.png"
                    }
                },
                "dateOfBirth": "1994-07-28",
                "properties": {
                    "position": {
                        "key": "DEFENDER",
                        "names": {
                            "default": "Defender",
                            "short": "D"
                        }
                    },
                    "lineupStatus": {
                        "key": "STARTER",
                        "names": {
                            "default": "Starter",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "16",
                    "positionNumber": "2"
                }
            },
            {
                "id": "GNB56CBPM0DA989",
                "names": {
                    "first": "Arijan",
                    "default": "Arijan Ademi",
                    "short": "A. Ademi",
                    "last": "Ademi"
                },
                "images": {
                    "playerHeadshot": "https://images.sports.gracenote.com/images/lib/basic/person/pp_clubteam/large/742270.jpg"
                },
                "nationality": {
                    "names": {
                        "default": "República de Macedonia del Norte",
                        "abbreviation": "MKD"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4358.png"
                    }
                },
                "dateOfBirth": "1991-05-29",
                "properties": {
                    "position": {
                        "key": "MIDFIELDER",
                        "names": {
                            "default": "Midfielder",
                            "short": "M"
                        }
                    },
                    "lineupStatus": {
                        "key": "STARTER",
                        "names": {
                            "default": "Starter",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "5",
                    "positionNumber": "7"
                }
            },
            {
                "id": "GN4RM00CVZ6T01K",
                "names": {
                    "first": "Ezgjan",
                    "last": "Alioski",
                    "short": "E. Alioski",
                    "default": "Ezgjan Alioski"
                },
                "images": {
                    "playerHeadshotNational": "https://images.sports.gracenote.com/images/lib/basic/person/pp_nationalteam/large/949726.jpg"
                },
                "nationality": {
                    "names": {
                        "default": "República de Macedonia del Norte",
                        "abbreviation": "MKD"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4358.png"
                    }
                },
                "dateOfBirth": "1992-02-12",
                "properties": {
                    "position": {
                        "key": "DEFENDER",
                        "names": {
                            "default": "Defender",
                            "short": "D"
                        }
                    },
                    "lineupStatus": {
                        "key": "STARTER",
                        "names": {
                            "default": "Starter",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "8",
                    "positionNumber": "6"
                }
            },
            {
                "id": "GN973G1NZYQ6XHK",
                "names": {
                    "short": "E. Elmas",
                    "default": "Eljif Elmas",
                    "first": "Eljif",
                    "last": "Elmas"
                },
                "images": {
                    "playerHeadshotNational": "https://images.sports.gracenote.com/images/lib/basic/person/pp_nationalteam/large/1693606.jpg",
                    "playerHeadshot": "https://images.sports.gracenote.com/images/lib/basic/person/pp_clubteam/large/1693606.jpg"
                },
                "nationality": {
                    "names": {
                        "default": "República de Macedonia del Norte",
                        "abbreviation": "MKD"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4358.png"
                    }
                },
                "dateOfBirth": "1999-09-24",
                "properties": {
                    "position": {
                        "key": "FORWARD",
                        "names": {
                            "default": "Forward",
                            "short": "F"
                        }
                    },
                    "lineupStatus": {
                        "key": "STARTER",
                        "names": {
                            "default": "Starter",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "21",
                    "positionNumber": "11"
                }
            },
            {
                "id": "GNEA2Q7PAKSCTB5",
                "names": {
                    "short": "E. Bardhi",
                    "last": "Bardhi",
                    "default": "Enis Bardhi",
                    "first": "Enis"
                },
                "images": {
                    "playerHeadshotNational": "https://images.sports.gracenote.com/images/lib/basic/person/pp_nationalteam/large/1324289.jpg",
                    "playerHeadshot": "https://images.sports.gracenote.com/images/lib/basic/person/pp_clubteam/large/1324289.jpg"
                },
                "nationality": {
                    "names": {
                        "default": "República de Macedonia del Norte",
                        "abbreviation": "MKD"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4358.png"
                    }
                },
                "dateOfBirth": "1995-07-02",
                "properties": {
                    "position": {
                        "key": "MIDFIELDER",
                        "names": {
                            "default": "Midfielder",
                            "short": "M"
                        }
                    },
                    "lineupStatus": {
                        "key": "STARTER",
                        "names": {
                            "default": "Starter",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "17",
                    "positionNumber": "9"
                }
            },
            {
                "id": "GN4890CNCGAQA93",
                "names": {
                    "default": "Goran Pandev",
                    "first": "Goran",
                    "short": "G. Pandev",
                    "last": "Pandev"
                },
                "images": {
                    "playerHeadshot": "https://images.sports.gracenote.com/images/lib/basic/person/pp_clubteam/large/357688.jpg",
                    "playerHeadshotNational": "https://images.sports.gracenote.com/images/lib/basic/person/pp_nationalteam/large/357688.jpg"
                },
                "nationality": {
                    "names": {
                        "default": "República de Macedonia del Norte",
                        "abbreviation": "MKD"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4358.png"
                    }
                },
                "dateOfBirth": "1983-07-27",
                "properties": {
                    "position": {
                        "key": "FORWARD",
                        "names": {
                            "default": "Forward",
                            "short": "F"
                        }
                    },
                    "role": {
                        "key": "CAPTAIN",
                        "names": {
                            "default": "Captain",
                            "short": "C"
                        }
                    },
                    "lineupStatus": {
                        "key": "STARTER",
                        "names": {
                            "default": "Starter",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "10",
                    "positionNumber": "10"
                }
            },
            {
                "id": "GNC0PMYZQ5QR9SE",
                "names": {
                    "last": "Spirovski",
                    "first": "Stefan",
                    "default": "Stefan Spirovski",
                    "short": "S. Spirovski"
                },
                "images": {
                    "playerHeadshotNational": "https://images.sports.gracenote.com/images/lib/basic/person/pp_nationalteam/large/790700.jpg"
                },
                "nationality": {
                    "names": {
                        "default": "República de Macedonia del Norte",
                        "abbreviation": "MKD"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4358.png"
                    }
                },
                "dateOfBirth": "1990-08-23",
                "properties": {
                    "position": {
                        "key": "MIDFIELDER",
                        "names": {
                            "default": "Midfielder",
                            "short": "M"
                        }
                    },
                    "lineupStatus": {
                        "key": "STARTER",
                        "names": {
                            "default": "Starter",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "20",
                    "positionNumber": "8"
                }
            },
            {
                "id": "GNCQGNHMCNMGFE1",
                "names": {
                    "last": "Jankov",
                    "default": "Risto Jankov",
                    "first": "Risto",
                    "short": "R. Jankov"
                },
                "images": {},
                "nationality": {
                    "names": {
                        "default": "República de Macedonia del Norte",
                        "abbreviation": "MKD"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4358.png"
                    }
                },
                "dateOfBirth": "1998-09-05",
                "properties": {
                    "lineupStatus": {
                        "key": "SUBSTITUTE",
                        "names": {
                            "default": "Substitute",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "12"
                }
            },
            {
                "id": "GN6B9DVDTE0CRV5",
                "names": {
                    "first": "Damjan",
                    "default": "Damjan Šiškovski",
                    "last": "Šiškovski",
                    "short": "D. Šiškovski"
                },
                "images": {},
                "nationality": {
                    "names": {
                        "default": "República de Macedonia del Norte",
                        "abbreviation": "MKD"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4358.png"
                    }
                },
                "dateOfBirth": "1995-03-18",
                "properties": {
                    "lineupStatus": {
                        "key": "SUBSTITUTE",
                        "names": {
                            "default": "Substitute",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "22"
                }
            },
            {
                "id": "GN09363YCNEQFJV",
                "names": {
                    "default": "Egzon Bejtulai",
                    "first": "Egzon",
                    "short": "E. Bejtulai",
                    "last": "Bejtulai"
                },
                "images": {},
                "nationality": {
                    "names": {
                        "default": "República de Macedonia del Norte",
                        "abbreviation": "MKD"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4358.png"
                    }
                },
                "dateOfBirth": "1994-01-07",
                "properties": {
                    "lineupStatus": {
                        "key": "SUBSTITUTE",
                        "names": {
                            "default": "Substitute",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "2"
                }
            },
            {
                "id": "GN62RE5AADHKH6G",
                "names": {
                    "last": "Ristevski",
                    "default": "Kire Ristevski",
                    "short": "K. Ristevski",
                    "first": "Kire"
                },
                "images": {
                    "playerHeadshotNational": "https://images.sports.gracenote.com/images/lib/basic/person/pp_nationalteam/large/790683.jpg"
                },
                "nationality": {
                    "names": {
                        "default": "República de Macedonia del Norte",
                        "abbreviation": "MKD"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4358.png"
                    }
                },
                "dateOfBirth": "1990-10-22",
                "properties": {
                    "position": {
                        "key": "DEFENDER",
                        "names": {
                            "default": "Defender",
                            "short": "D"
                        }
                    },
                    "lineupStatus": {
                        "key": "SUBSTITUTE",
                        "names": {
                            "default": "Substitute",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "4",
                    "positionNumber": "7"
                }
            },
            {
                "id": "GNFDTRKVDQKEC6X",
                "names": {
                    "last": "Trickovski",
                    "first": "Ivan",
                    "default": "Ivan Trickovski",
                    "short": "I. Trickovski"
                },
                "images": {
                    "playerHeadshot": "https://images.sports.gracenote.com/images/lib/basic/person/pp_clubteam/large/694030.jpg"
                },
                "nationality": {
                    "names": {
                        "default": "República de Macedonia del Norte",
                        "abbreviation": "MKD"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4358.png"
                    }
                },
                "dateOfBirth": "1987-04-18",
                "properties": {
                    "position": {
                        "key": "FORWARD",
                        "names": {
                            "default": "Forward",
                            "short": "F"
                        }
                    },
                    "lineupStatus": {
                        "key": "SUBSTITUTE",
                        "names": {
                            "default": "Substitute",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "7",
                    "positionNumber": "4"
                }
            },
            {
                "id": "GN4ZYCJ3R3SXNEA",
                "names": {
                    "first": "Ferhan",
                    "short": "F. Hasani",
                    "default": "Ferhan Hasani",
                    "last": "Hasani"
                },
                "images": {
                    "playerHeadshot": "https://images.sports.gracenote.com/images/lib/basic/person/pp_clubteam/large/875799.jpg",
                    "playerHeadshotNational": "https://images.sports.gracenote.com/images/lib/basic/person/pp_nationalteam/large/875799.jpg"
                },
                "nationality": {
                    "names": {
                        "default": "República de Macedonia del Norte",
                        "abbreviation": "MKD"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4358.png"
                    }
                },
                "dateOfBirth": "1990-06-18",
                "properties": {
                    "lineupStatus": {
                        "key": "SUBSTITUTE",
                        "names": {
                            "default": "Substitute",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "11"
                }
            },
            {
                "id": "GNFKFBDP4F1JY6K",
                "names": {
                    "default": "Aleksandar Trajkovski",
                    "first": "Aleksandar",
                    "short": "A. Trajkovski",
                    "last": "Trajkovski"
                },
                "images": {
                    "playerHeadshot": "https://images.sports.gracenote.com/images/lib/basic/person/pp_clubteam/large/920939.jpg"
                },
                "nationality": {
                    "names": {
                        "default": "República de Macedonia del Norte",
                        "abbreviation": "MKD"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4358.png"
                    }
                },
                "dateOfBirth": "1992-09-05",
                "properties": {
                    "position": {
                        "key": "FORWARD",
                        "names": {
                            "default": "Forward",
                            "short": "F"
                        }
                    },
                    "lineupStatus": {
                        "key": "SUBSTITUTE",
                        "names": {
                            "default": "Substitute",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "9",
                    "positionNumber": "2"
                }
            },
            {
                "id": "GNFM510BZHE0N83",
                "names": {
                    "short": "M. Radeski",
                    "last": "Radeski",
                    "first": "Marjan",
                    "default": "Marjan Radeski"
                },
                "images": {
                    "playerHeadshotNational": "https://images.sports.gracenote.com/images/lib/basic/person/pp_nationalteam/large/1030256.jpg"
                },
                "nationality": {
                    "names": {
                        "default": "República de Macedonia del Norte",
                        "abbreviation": "MKD"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4358.png"
                    }
                },
                "dateOfBirth": "1995-02-10",
                "properties": {
                    "lineupStatus": {
                        "key": "SUBSTITUTE",
                        "names": {
                            "default": "Substitute",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "23"
                }
            },
            {
                "id": "GNBFYJ3SZ2050TN",
                "names": {
                    "last": "Kostadinov",
                    "short": "T. Kostadinov",
                    "first": "Tihomir",
                    "default": "Tihomir Kostadinov"
                },
                "images": {},
                "nationality": {
                    "names": {
                        "default": "República de Macedonia del Norte",
                        "abbreviation": "MKD"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4358.png"
                    }
                },
                "dateOfBirth": "1996-03-04",
                "properties": {
                    "lineupStatus": {
                        "key": "SUBSTITUTE",
                        "names": {
                            "default": "Substitute",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "15"
                }
            },
            {
                "id": "GN80SWYP6TQ3D4H",
                "names": {
                    "default": "Darko Churlinov",
                    "short": "D. Churlinov",
                    "last": "Churlinov",
                    "first": "Darko"
                },
                "images": {
                    "playerHeadshot": "https://images.sports.gracenote.com/images/lib/basic/person/pp_clubteam/large/1642614.jpg"
                },
                "nationality": {
                    "names": {
                        "default": "República de Macedonia del Norte",
                        "abbreviation": "MKD"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4358.png"
                    }
                },
                "dateOfBirth": "2000-07-11",
                "properties": {
                    "position": {
                        "key": "MIDFIELDER",
                        "names": {
                            "default": "Midfielder",
                            "short": "M"
                        }
                    },
                    "lineupStatus": {
                        "key": "SUBSTITUTE",
                        "names": {
                            "default": "Substitute",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "25",
                    "positionNumber": "8"
                }
            },
            {
                "id": "GN2JS1ZMQCE681X",
                "names": {
                    "short": "D. Avramovski",
                    "last": "Avramovski",
                    "first": "Daniel",
                    "default": "Daniel Avramovski"
                },
                "images": {},
                "nationality": {
                    "names": {
                        "default": "República de Macedonia del Norte",
                        "abbreviation": "MKD"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4358.png"
                    }
                },
                "dateOfBirth": "1995-02-20",
                "properties": {
                    "position": {
                        "key": "MIDFIELDER",
                        "names": {
                            "default": "Midfielder",
                            "short": "M"
                        }
                    },
                    "lineupStatus": {
                        "key": "SUBSTITUTE",
                        "names": {
                            "default": "Substitute",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "24",
                    "positionNumber": "9"
                }
            },
            {
                "id": "GN7ZJHKF1P3P8XP",
                "names": {
                    "first": "Milan",
                    "last": "Ristovski",
                    "default": "Milan Ristovski",
                    "short": "M. Ristovski"
                },
                "images": {},
                "nationality": {
                    "names": {
                        "default": "República de Macedonia del Norte",
                        "abbreviation": "MKD"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4358.png"
                    }
                },
                "dateOfBirth": "1998-04-08",
                "properties": {
                    "lineupStatus": {
                        "key": "SUBSTITUTE",
                        "names": {
                            "default": "Substitute",
                            "short": "S"
                        }
                    },
                    "uniformNumber": "26"
                }
            }
        ],
        "coaches": [
            {
                "id": "GN5R0CE1VRDS53A",
                "names": {
                    "default": "Igor Angelovski",
                    "short": "I. Angelovski",
                    "last": "Angelovski",
                    "first": "Igor"
                },
                "images": {
                    "playerHeadshotNational": "https://images.sports.gracenote.com/images/lib/basic/person/pp_nationalteam/large/1418890.jpg"
                },
                "nationality": {
                    "names": {
                        "default": "República de Macedonia del Norte",
                        "abbreviation": "MKD"
                    },
                    "images": {
                        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4358.png"
                    }
                },
                "dateOfBirth": "1976-06-02",
                "properties": {
                    "role": {
                        "key": "COACH",
                        "names": {
                            "default": "Coach",
                            "short": "C"
                        }
                    }
                }
            }
        ]
    },
    "officials": [
        {
            "id": "GN54Y1FYCQB92B9",
            "names": {
                "last": "Rapallini",
                "default": "Fernando Rapallini",
                "first": "Fernando",
                "short": "F. Rapallini"
            },
            "images": {},
            "nationality": {
                "names": {
                    "abbreviation": "ARG",
                    "default": "Argentina"
                },
                "images": {
                    "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2768.png"
                }
            },
            "properties": {
                "position": {
                    "key": "REFEREE",
                    "names": {
                        "default": "Referee",
                        "short": "Ref."
                    }
                }
            }
        },
        {
            "id": "GN4VFSJC63A2A99",
            "names": {
                "first": "Juan Pablo",
                "short": "J. P. Belatti",
                "default": "Juan Pablo Belatti",
                "last": "Belatti"
            },
            "images": {},
            "nationality": {
                "names": {
                    "abbreviation": "ARG",
                    "default": "Argentina"
                },
                "images": {
                    "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2768.png"
                }
            },
            "dateOfBirth": "1979-04-15",
            "properties": {
                "position": {
                    "key": "ASSISTANT_REFEREE",
                    "names": {
                        "default": "Assistant referee",
                        "short": "LM"
                    }
                }
            }
        },
        {
            "id": "GN9Q1G14PWPSJJX",
            "names": {
                "last": "Bonfa",
                "default": "Diego Bonfa",
                "first": "Diego",
                "short": "D. Bonfa"
            },
            "images": {},
            "nationality": {
                "names": {
                    "abbreviation": "ARG",
                    "default": "Argentina"
                },
                "images": {
                    "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2768.png"
                }
            },
            "properties": {
                "position": {
                    "key": "ASSISTANT_REFEREE",
                    "names": {
                        "default": "Assistant referee",
                        "short": "LM"
                    }
                }
            }
        },
        {
            "id": "GN999RMNX9ZC0HQ",
            "names": {
                "last": "Vincic",
                "short": "S. Vincic",
                "default": "Slavko Vincic",
                "first": "Slavko"
            },
            "images": {},
            "nationality": {
                "names": {
                    "abbreviation": "SLO",
                    "default": "Eslovenia"
                },
                "images": {
                    "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2783.png"
                }
            },
            "dateOfBirth": "1979-11-25",
            "properties": {
                "position": {
                    "key": "4TH_OFFICIAL",
                    "names": {
                        "default": "4th Official",
                        "short": "4 Off."
                    }
                }
            }
        }
    ]
}`);



// const newlineup = JSON.parse(`{
//     "homeLineup": {
//         "formation": "",
//         "players": [],
//         "coach": {
//             "id": "",
//             "name": "",
//             "lastname": "",
//             "firstname": "",
//             "image": "",
//             "nationality": "",
//             "nationalityAbbrev": ""
//         }
//     },
//     "awayLineup": {
//         "formation": "",
//         "players": [],
//         "coach": {
//             "id": "",
//             "name": "",
//             "lastname": "",
//             "firstname": "",
//             "image": "",
//             "nationality": "",
//             "nationalityAbbrev": ""
//         }
//     }
// }`);

// newlineup.homeLineup.formation = mockChampionsLineup.homeLineup.team.properties.formation;
// newlineup.awayLineup.formation = mockChampionsLineup.awayLineup.team.properties.formation;
// newlineup.homeLineup.coach = parsePlayer(mockChampionsLineup.homeLineup.coaches[0]);
// newlineup.awayLineup.coach = parsePlayer(mockChampionsLineup.awayLineup.coaches[0]);

// newlineup.homeLineup.players = mockChampionsLineup.homeLineup.teamMembers.map(parsePlayer);
// newlineup.awayLineup.players = mockChampionsLineup.awayLineup.teamMembers.map(parsePlayer);

// export const lineup = newlineup;


// WEBPACK FOOTER //
// ./src/mundial/requests/mockData/lineup.ts